import { ExtendedFormSchema } from '../components/form-schema';
import { defaultValuesV2, type FormSchemaV2 } from '../types/form-schema-v2';
import { getSummaryDefaultText } from './default-text';

export const clientDefaultValues = (
  data: Parameters<typeof getSummaryDefaultText>[0],
  campaignName: string
): ExtendedFormSchema => {
  const highlightsString = getSummaryDefaultText(data, campaignName);

  return {
    campaignName,
    summary: highlightsString,
    retailersSummary: {
      takeaways: [],
      recommendation: '',
    },
    performanceByRetailer: {
      recommendation: '',
    },
    includedSlides: {
      overall: {
        overview: true,
        executiveSummary: true,
      },
      salesAttribution: {
        titleSlide: true,
        summary: true,
        dimensions: true,
      },
      performanceByRetailer: {
        titleSlide: true,
        retailerSummary: true,
        performanceByTopTen: true,
      },
      appendix: true,
    },
    dimensions: {
      agency: {
        tableHeader: '',
        checkbox: true,
      },
      brand: {
        tableHeader: '',
        checkbox: true,
      },
      ad: {
        tableHeader: '',
        checkbox: true,
      },
      aud: {
        tableHeader: '',
        checkbox: true,
      },
      creative: {
        tableHeader: '',
        checkbox: true,
      },
      channel: {
        tableHeader: '',
        checkbox: true,
      },
      publisher: {
        tableHeader: '',
        checkbox: true,
      },
      site: {
        tableHeader: '',
        checkbox: true,
      },
      inv_type: {
        tableHeader: '',
        checkbox: true,
      },
      plcmnt: {
        tableHeader: '',
        checkbox: true,
      },
      typ: {
        tableHeader: '',
        checkbox: true,
      },
      ds: {
        tableHeader: '',
        checkbox: true,
      },
      iol: {
        tableHeader: '',
        checkbox: true,
      },
      ad_frequency: {
        tableHeader: '',
        checkbox: true,
      },
      visit_frequency: {
        tableHeader: '',
        checkbox: true,
      },
      Top: { tableHeader: '', checkbox: true },
      Bottom: { tableHeader: '', checkbox: true },
    },
  };
};

export const clientDefaultValuesV2 = (
  data: Parameters<typeof getSummaryDefaultText>[0],
  campaignName: string
): FormSchemaV2 => ({
  ...defaultValuesV2,
  campaignName,
  summary: getSummaryDefaultText(data, campaignName),
});
